<div class="backdrop show" (click)="onCloseForm()"></div>

<div class="sidepanel show">
  <div class="header">
    <span>{{ isCreateMode ? 'Create Feature' : 'Edit Feature' }}</span>
    <nx-icon [name]="'close'" size="s" (click)="onCloseForm()"></nx-icon>
  </div>

  <div class="body">
    @if (featureForm && !isFeatureLoading && responseError?.errorType !== 'loadFeature') {
    <form [formGroup]="featureForm">
      @if (!isCreateMode) {
      <nx-formfield appearance="outline" label="Feature ID" floatLabel="always">
        <input nxInput formControlName="featureId" readonly />
      </nx-formfield>
      }
      <nx-formfield appearance="outline" label="Feature Name" floatLabel="always">
        <input nxInput formControlName="featureName"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Contact Email" floatLabel="always">
        <input nxInput type="email" formControlName="contactEmail"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Email Distributions" floatLabel="always">
        <input nxInput #addEmailDistributionInput
          (keydown.enter)="$event.preventDefault(); addEmailToDistributions(addEmailDistributionInput.value, addEmailDistributionInput)"
          (keydown.space)="$event.preventDefault(); addEmailToDistributions(addEmailDistributionInput.value, addEmailDistributionInput)"
          (keydown.,)="$event.preventDefault(); addEmailToDistributions(addEmailDistributionInput.value, addEmailDistributionInput)"
          [readonly]="!(permissionService.can_write_service_config$ | async)"
          placeholder="Type email and press Enter, Space, or Comma to add" />
      </nx-formfield>
      <nx-taglist [(tags)]="emailDistributions"
        [class.read-only]="!(permissionService.can_write_service_config$ | async)"></nx-taglist>

      @if (responseError && (responseError.errorType === 'updateFeature' || responseError.errorType ===
      'createFeature')) {
      <nx-message context="error">
        <span class="nx-font-weight-bold">{{ responseError.error }}</span><br />
        {{ responseError.details }}
      </nx-message>
      }
      @if (permissionService.can_write_service_config$ | async) {
      <button nxButton="primary small" type="button" [class.has-spinner]="isFeatureUpdating"
        [disabled]="!featureForm.valid" (click)="updateFeature(addEmailDistributionInput)">
        @if (isFeatureUpdating) {
        <nx-spinner size="medium"></nx-spinner>
        }
        {{ isCreateMode ? 'Create Feature' : 'Update Feature' }}
      </button>
      }
    </form>
    }

    @if (responseError && responseError.errorType === 'loadFeature') {
    <nx-message context="error">
      <span class="nx-font-weight-bold">{{ responseError.error }}</span><br />
      {{ responseError.details }}
    </nx-message>
    }

    @if (isFeatureLoading) {
    <nx-spinner size="large"></nx-spinner>
    }
  </div>
</div>